import React, { useState } from "react";
import axios from "axios";
import "./App.css";
import { API } from "./api";

export default function LoginPopup({ onLogin }) {
  const [username, setUser] = useState("");
  const [password, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submitLogin = async (e) => {
    e?.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/login`, { username, password });
      if (res.data.status === "success") {
        onLogin(res.data.role, res.data.name || "");
      } else {
        setError(res.data.message || "Sai tên đăng nhập hoặc mật khẩu");
      }
    } catch {
      setError("Không kết nối được tới máy chủ");
    }
    setLoading(false);
  };

  return (
    <div className="login-overlay">
      <div className="login-box">
        <div className="login-banner">
          <img src="/logo.png" alt="logo" />
          <h2>Ảnh Nội Bộ Bệnh Viện</h2>
          <p>Hùng Vương Gia Lai</p>
        </div>

        <form className="login-form" onSubmit={submitLogin}>
          <label>Mã số nhân viên</label>
          <input
            type="text"
            placeholder="Nhập mã số nhân viên..."
            value={username}
            onChange={(e) => setUser(e.target.value)}
            autoFocus
          />

          <label>Mật khẩu</label>
          <input
            type="password"
            placeholder="Nhập mật khẩu..."
            value={password}
            onChange={(e) => setPass(e.target.value)}
          />

          {error && <div className="login-error">{error}</div>}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Đang đăng nhập..." : "Đăng nhập"}
          </button>
        </form>
      </div>
    </div>
  );
}
